module.exports = __webpack_public_path__ + "static/media/review.7837b05e.svg";